import { useMemo } from 'react';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';

const RealEstateSchema = z.object({
  PersonID: z.string(),
  CollateralID: z.string().optional(),

  OwnershipType: z.string().optional(),
  RealEstateType: z.string().optional(),

  EstimatedValueReferenceNumber: z.string().optional(),

  MarketScoreArea: z.number().optional(),
  MarketScoreMunicipality: z.number().optional(),

  CadastreBNumber: z.string().optional(),
  CadastreFNumber: z.string().optional(),
  CadastreGNumber: z.string().optional(),
  CadastreKNumber: z.string().optional(),
  CadastreSNumber: z.string().optional(),

  PrimaryLivingArea: z.number().optional(),

  StreetName: z.string().optional(),
  StreetNumber: z.string().optional(),
  StreetLetter: z.string().optional(),
  Postcode: z.string().optional(),
  Municipality: z.string().optional(),

  TotalMarketValueEstimate: z.number().optional(),
  TotalMarketValueEstimateApproved: z.number().optional(),

  IsInsured: z.boolean().optional(),
  InsuranceCompany: z.string().optional(),

  CooperativeApartmentCommonDebt: z.number().optional(),
  CooperativeApartmentOrganizationNumber: z.string().optional(),
  CooperativeApartmentShareNumber: z.string().optional(),

  Source: z.string().optional(),
  FetchID: z.string().optional(),
});

const CollateralFormSchema = z.object({
  estates: z.record(z.string(), RealEstateSchema),
  isCollateral: z.record(z.string(), z.boolean()),
});

export const useCollateralFormSchema = (_applicationID: string) => {
  return CollateralFormSchema;
};

export const useCollateralFormSchemaResolver = (applicationID: string) => {
  const schema = useCollateralFormSchema(applicationID);

  return useMemo(
    () => zodResolver(schema, { async: true }, { mode: 'async' }),
    [schema],
  );
};

export type CollateralFormDataValues = z.infer<
  ReturnType<typeof useCollateralFormSchema>
>;
